import { Component, OnInit, Input, OnChanges } from 'angular-ts-decorators';

/**
 * Component that shows a progress indicator
 */
@Component({
  selector: 'swProgressCircle',
})
export class SwProgressCircleComponent implements OnInit, OnChanges {
  @Input() thickness: any;
  @Input() size: any;
  @Input() value: any;
  @Input() max: any;

  min: number;
  total: number;
  svg: any;
  path: any;
  offset: number;

  constructor(
    private $element,
    private $document: ng.IDocumentService,
  ) {
    'ngInject';
  }

  private create(elementName: string) {
    return this.$document[0].createElementNS(
      'http://www.w3.org/2000/svg',
      elementName,
    );
  }

  private updatePath() {
    if (!this.path) {
      return;
    }
    const percent = (this.value - this.min) / (this.max - this.min);
    this.path.setAttribute(
      'stroke-dashoffset',
      this.total - percent * this.total,
    );
  }

  private updateSize() {
    const half = Math.floor(this.size / 2);
    this.size = half * 2;
    this.svg.style.width = `${this.size}px`;
    this.svg.style.height = `${this.size}px`;
    const quarter = Math.floor(half / 2);
    const halfThickness = Math.ceil(this.thickness / 2);
    this.path.setAttribute(
      'd',
      `M${halfThickness},${half}
        A${quarter},${quarter} 0 0,1 ${this.size - halfThickness},${half}
        A${quarter},${quarter} 0 0,1 ${halfThickness},${half}`,
    );

    this.total = this.path.getTotalLength();
    this.path.setAttribute('stroke-dasharray', `${this.total} ${this.total}`);
    this.path.setAttribute(
      'transform',
      `rotate(${this.offset} ${half} ${half})`,
    );
  }

  ngOnInit() {
    this.min = 0;
    this.max = this.max || 100;
    this.total = 0;
    this.offset = 0;
    this.svg = null;

    this.svg = this.create('svg');
    this.svg.setAttribute('class', 'sw-progress-circle');
    this.path = this.create('path');
    this.updateSize();
    this.updatePath();
    this.svg.appendChild(this.path);
    this.$element.append(this.svg);
  }

  ngOnChanges(changes) {
    if (changes.value && changes.value.currentValue !== undefined) {
      this.value = changes.value.currentValue;
    }
    this.updatePath();
  }
}
